/**
 * Retarder field formatter
 */

import {useRetarder} from '@hconnect/tuc-processes/fields'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'

import type {FieldFormatter} from './types'
import {createValueArray} from './utils'

export const useRetarderFormatter = (): FieldFormatter => {
  const {retarder, defaultRetarder} = useRetarder()
  const retarderState = useChangeableField('materialVariations')

  return (context) => {
    const {t} = context
    const requiresApproval = retarderState.state === 'requireDispatchConfirmation'
    const hasChanges = retarderState.isDirty

    const oldValue = defaultRetarder?.retarder
      ? `${defaultRetarder.retarder} ${defaultRetarder.retarderUom}`
      : null
    const newValue = retarder?.retarder ? `${retarder.retarder} ${retarder.retarderUom}` : null

    const values = createValueArray(
      oldValue,
      newValue,
      hasChanges,
      t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified')
    )

    return {values, requiresApproval, hasChanges}
  }
}
